/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable default-case */
// import { Layout } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import uuid from 'react-uuid';
import { UserOutlined, EyeOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Form, Input, Divider, Typography, Modal, Row, Col, Upload, Image, message, Radio, Space, DatePicker, Select } from 'antd';
import "../Application.scss"
import Utils from '../../../misc/Utils';
import moment from 'moment';
import ProcessingModal from '../../../components/processing/ProcessingModal';

const { Title, Text } = Typography;
const { Dragger, LIST_IGNORE } = Upload;
const DOCUMENT_TYPES = {
   picture: 'sp',
   birthCertificate: 'bc',
   reportCard: 'rc',
   proofOfPayment: 'pop',
   medicalCertificate: 'medcert',
};

const INITIAL_DOCUMENT_PREVIEWS = {
   [DOCUMENT_TYPES.picture]: null,
   [DOCUMENT_TYPES.birthCertificate]: null,
   [DOCUMENT_TYPES.reportCard]: null,
   [DOCUMENT_TYPES.proofOfPayment]: null,
   [DOCUMENT_TYPES.medicalCertificate]: null,
};

const DOCUMENT_UPLOAD_ITEMS = [
   { key: DOCUMENT_TYPES.birthCertificate, label: 'Birth Certificate (PSA Accredited)' },
   { key: DOCUMENT_TYPES.reportCard, label: 'Report Card or Diploma' },
   { key: DOCUMENT_TYPES.medicalCertificate, label: 'Medical Certificate' },
];

const MEDICAL_CERTIFICATE_TOOLTIP = `Reminder on the Medical Clearance / Certificate:
THERE IS NO NEED TO UPLOAD ALL YOUR LABORATORY RESULTS. We only require the Medical Certificate or Medical Clearance FROM YOUR results. Have your latest laboratory results checked by your doctor or physician and ask them to issue you the document we require.

Paalala ukol sa Medical Clearance / Certificate:
HINDI KAILANGANG I-UPLOAD ANG LAHAT NG IYONG MGA LABORATORY RESULTS. Kailangan lamang namin ang Medical Clearance o Medical Certificate MULA SA IYONG mga laboratory results. Ipa-check ang mga ito sa iyong doktor at hilingin sa kanila ang dokumentong aming kinakailangan.`;

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];
const ACCEPTED_DOC_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
const ACCEPTED_DOC_EXTENSIONS = '.jpg,.jpeg,.png,.pdf';
const LOCAL_HOSTNAME_PATTERN = /localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/i;

const safeParseJson = (value, fallback = null) => {
   if (value === null || value === undefined || value === '') return fallback;

   try {
      return JSON.parse(value);
   } catch (error) {
      console.error('Failed to parse online application data:', error);
      return fallback;
   }
};

const normalizeProgramType = (raw) => {
   if (!raw) return null;

   return String(raw).toLowerCase().includes('diploma') ? 'diploma' : 'certificate';
};

const getOfferingProgramType = (offering) => {
   if (!offering) return null;

   const explicit =
      normalizeProgramType(offering.program_type) ||
      normalizeProgramType(offering.programType) ||
      normalizeProgramType(offering.type) ||
      normalizeProgramType(offering.program) ||
      normalizeProgramType(offering.level) ||
      normalizeProgramType(offering.track);

   if (explicit) return explicit;

   const haystack = `${offering.name ?? ''} ${offering.value ?? ''}`.toLowerCase();
   return /\b(dip|diploma)\b/.test(haystack) ? 'diploma' : 'certificate';
};

const getUploadedDocumentUrl = (uploadedFiles, docType, baseS3Url) => (
   uploadedFiles[docType] ? `${baseS3Url}${uploadedFiles[docType]}` : ''
);

const isPdfDocument = (document) => {
   if (!document) return false;
   return String(document).startsWith('data:application/pdf') || /\.pdf($|\?)/i.test(String(document));
};

//-- Medical Examination Requirements
const mer = [
   {
      "id": "cbc",
      "label": "CBC (Complete Blood Count)",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "uri",
      "label": "Urinalysis",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "fec",
      "label": "Fecalysis",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "cxr",
      "label": "CXR (Chest X-Ray)",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "dt",
      "label": "Drug Test",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "pe",
      "label": "Physical Exam",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   },
   {
      "id": "pt",
      "label": "Pregnancy Test",
      "document": "",
      "status": "",
      "remarks": "",
      "required": false
   },
   {
      "id": "mc",
      "label": "Medical Certificate",
      "document": "",
      "status": "",
      "remarks": "",
      "required": true
   }
];

const dp_pop = {
   "document": "",
   "status": "",
   "receipt_no": ""
};

export function ApplicationMakati() {
   const [form] = Form.useForm();

   const subdomain = localStorage.getItem("lms-subdomain");

   const [docToView, setDocToView] = useState(null);
   const [updating, setUpdating] = useState(false);
   const [documentPreviews, setDocumentPreviews] = useState(INITIAL_DOCUMENT_PREVIEWS);
   const [filesForUpload, setFilesForUpload] = useState({});
   const [firstChoice, setFirstChoice] = useState(null);
   const [formValues, setFormValues] = useState(null);
   const medicalCertificateInputRef = useRef(null);

   // Course offering program selector
   // NOTE: API data may expose different keys; we support a few common ones and
   // also fall back to inferring the program from the course name/value.
   const [programType, setProgramType] = useState('certificate');

   const [oaData, setOAData] = useState({
      course_offering: null,
      bank_details: null,
      testing_fee: null,
      online_payment: null,
      has_online_application: null,
      school_name: null
   });

   const [modalVisible, setModalVisible] = useState(false);
   const [modalSubmit, setModalSubmit] = useState(false);

   useEffect(() => {
      getOAData();
   }, []);

   const getFilteredCourseOffering = () => {
      const list = oaData.course_offering;
      if (!Array.isArray(list)) return [];

      const filtered = list.filter((o) => {
         const t = getOfferingProgramType(o);
         // If the item doesn't declare a type, keep it visible in both lists
         // (prevents accidentally hiding everything if backend doesn't provide the field).
         if (!t) return true;
         return t === programType;
      });

      return filtered;
   };

   const filteredCourseOffering = getFilteredCourseOffering();

   useEffect(() => {
      if (!firstChoice) return;

      const stillValid = filteredCourseOffering.some((o) => o.value === firstChoice);
      if (!stillValid) {
         setFirstChoice(null);
         form.setFieldsValue({ first_choice: null });
      }
   }, [firstChoice, filteredCourseOffering, form]);

   const requiresPaymentProof = Number(oaData.testing_fee || 0) > 0;

   const resetApplicationState = () => {
      form.resetFields();
      setDocumentPreviews(INITIAL_DOCUMENT_PREVIEWS);
      setFirstChoice(null);
      setFilesForUpload({});
      setFormValues(null);
   };

   const getOAData = () => {
      const url = `${process.env.REACT_APP_API_CPH}/getoadata`;

      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;

            setOAData({
               course_offering: safeParseJson(data.course_offering, []),
               bank_details: safeParseJson(data.bank_details, []),
               testing_fee: data.testing_fee !== null && data.testing_fee !== undefined ? data.testing_fee : null,
               online_payment: safeParseJson(data.online_payment, []),
               has_online_application: data.has_oa !== null && data.has_oa !== undefined ? data.has_oa : null,
               school_name: data.school_name !== null && data.school_name !== undefined ? data.school_name : null,
            });
         }
      }, (error) => {
         console.log(error.message);
      });
   };

   const beforeDocUpload = (file, doctype) => {
      const allowedTypes = doctype === DOCUMENT_TYPES.picture ? ACCEPTED_IMAGE_TYPES : ACCEPTED_DOC_TYPES;
      const isValid = allowedTypes.includes(file.type);

      if (!isValid) {
         message.error(doctype === DOCUMENT_TYPES.picture
            ? 'You can only upload JPG or PNG files for the profile picture.'
            : 'You can only upload JPG, PNG, or PDF files.');
      }

      const isLt = file.size / 1024 / 1024 <= 10;
      if (!isLt) {
         message.error('File must be 10MB or smaller.');
      }

      if (isValid && isLt) {
         handleUpload(file, doctype);
      }

      return LIST_IGNORE;
   };

   const handleUpload = (file, doctype) => {
      setFilesForUpload((prev) => ({
         ...prev,
         [doctype]: file,
      }));

      Utils.getBase64(file, (imageb64) => {
         setDocumentPreviews((prev) => ({
            ...prev,
            [doctype]: imageb64,
         }));
      });
   };

   const renderPreviewer = (document) => {
      return <>
         <div
            className={'modal-document-viewer'}
            style={{ height: "calc(100vh - 195px)" }}
         >
            {
               isPdfDocument(document)
                  ? (
                     <iframe
                        src={document}
                        title="Document preview"
                        style={{ width: '100%', minHeight: 'calc(100vh - 195px)', border: 'none' }}
                     />
                  )
                  : (
                     <Image
                        src={document}
                        style={{ minHeight: "calc(100vh - 195px)", maxHeight: "calc(100vh - 195px)" }}
                     />
                  )
            }
         </div>
      </>
   };

   const handleViewDoc = (doc) => {
      setDocToView(doc);
      setModalVisible(true);
   };

   const onFinish = (values) => {
      setModalSubmit(true);
      setFormValues(values);
   };

   const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
   };

   const handleFirstChoice = (value) => {
      setFirstChoice(value);
   };

   const handleProgramTypeChange = (e) => {
      setProgramType(e.target.value);
   };

   const handleMedicalCertificateUploadClick = () => {
      Modal.info({
         title: 'Medical Certificate Reminder',
         content: <span style={{ whiteSpace: 'pre-line' }}>{MEDICAL_CERTIFICATE_TOOLTIP}</span>,
         centered: true,
         okText: 'OK',
         okButtonProps: { shape: 'round', type: 'primary' },
         onOk: () => {
            medicalCertificateInputRef.current?.click();
         },
      });
   };

   const handleMedicalCertificateFileChange = (e) => {
      const file = e.target.files && e.target.files[0];

      if (file) {
         beforeDocUpload(file, DOCUMENT_TYPES.medicalCertificate);
      }

      e.target.value = '';
   };

   const handleSaveApplication = async (data) => {
      const uploadEntries = Object.entries(filesForUpload);
      if (!uploadEntries.length) return;

      setUpdating(true);
      try {
         const formData = new FormData();
         uploadEntries.forEach(([, file]) => formData.append('files', file));
         const uploadUrl = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_ONLINE_APPLICATION_PATH}`;
         const { data: uploadedFiles } = await axios.post(uploadUrl, formData);

         if (!uploadedFiles) throw new Error('Upload failed');

         const o2oMode = LOCAL_HOSTNAME_PATTERN.test(window.location.hostname) ? 'offline' : 'online';
         const id = `online_application_${o2oMode}_${uuid()}`;
         const baseS3Url = `${process.env.REACT_APP_API_S3_URL}/${subdomain}/online-application/`;
         const uploadedFilesArray = String(uploadedFiles).split(',');
         const uploadedFilesByType = uploadEntries.reduce((acc, [docType], index) => {
            if (uploadedFilesArray[index]) {
               acc[docType] = uploadedFilesArray[index];
            }

            return acc;
         }, {});

         const otherData = {
            number_street: data.number_street,
            barangay: data.barangay,
            district: data.district,
            city_municipality: data.city_municipality,
            province: data.province,
            region: data.region,
            nationality: data.nationality,
            civil_status: data.civil_status,
            employment_status: data.employment_status,
            birth_place: data.birth_place,
            educational_attainment: data.educational_attainment,
            parent_guardian_name: data.parent_guardian_name,
            parent_guardian_address: data.parent_guardian_address,
            first_choice: firstChoice,
            second_choice: null,
         };

         const documents = {
            birth_certificate: getUploadedDocumentUrl(uploadedFilesByType, DOCUMENT_TYPES.birthCertificate, baseS3Url),
            report_card: getUploadedDocumentUrl(uploadedFilesByType, DOCUMENT_TYPES.reportCard, baseS3Url),
            af_proof_of_payment: getUploadedDocumentUrl(uploadedFilesByType, DOCUMENT_TYPES.proofOfPayment, baseS3Url),
            medical_certificate: getUploadedDocumentUrl(uploadedFilesByType, DOCUMENT_TYPES.medicalCertificate, baseS3Url),
            _proof_of_payment: '',
         };

         const applicantData = {
            id,
            last_name: data.last_name,
            first_name: data.first_name,
            middle_name: data.middle_name,
            gender: data.gender,
            birth_date: moment(data.birth_date).format('YYYY-MM-DD'),
            email: data.email,
            contact_number: data.contact_no,
            other_info: JSON.stringify(otherData),
            picture: getUploadedDocumentUrl(uploadedFilesByType, DOCUMENT_TYPES.picture, baseS3Url),
            documents: JSON.stringify(documents),
            application_status: 'pending',
            bank_details: data.bank_details,
            mer: JSON.stringify(mer),
            dp_pop: JSON.stringify(dp_pop),
         };

         // Save applicant data
         const { data: result } = await axios.post(`${process.env.REACT_APP_API_CPH}/v2/upsertonlineapplicant`, applicantData);

         if (result === 2) {
            Modal.info({
               title: 'Online Application',
               content: 'The applicant you entered has already submitted an application.',
               centered: true,
            });
         } else {
            Modal.success({
               title: 'Online Application',
               content: 'Application posted.',
               centered: true,
            });
            resetApplicationState();
         }
      } catch (error) {
         console.error('Error saving application:', error.message);
         Modal.error({
            title: 'Online Application',
            content: 'It seems that there was a problem encountered while processing your request.',
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   };

   const handleSubmitApplication = (values) => {
      setModalSubmit(false);

      const missingDocs = [
         !documentPreviews[DOCUMENT_TYPES.picture] && 'Picture',
         !documentPreviews[DOCUMENT_TYPES.birthCertificate] && 'Birth Certificate (PSA Accredited)',
         !documentPreviews[DOCUMENT_TYPES.reportCard] && 'Report Card or Diploma',
         !documentPreviews[DOCUMENT_TYPES.medicalCertificate] && 'Medical Certificate',
         !documentPreviews[DOCUMENT_TYPES.proofOfPayment] && requiresPaymentProof && 'Proof of Payment',
      ].filter(Boolean);

      if (missingDocs.length > 0) {
         Modal.info({
            title: 'Online Application',
            content: (
               <>
                  Please provide the following:
                  <ul>{missingDocs.map((doc, i) => <li key={i}>{doc}</li>)}</ul>
               </>
            ),
            centered: true,
         });
         return;
      }

      handleSaveApplication(values);
   };

   const renderDocumentUploadAction = (docType) => {
      const isMedicalCertificate = docType === DOCUMENT_TYPES.medicalCertificate;

      return (
         <Space>
            {
               isMedicalCertificate
                  ? (
                     <>
                        <input
                           ref={medicalCertificateInputRef}
                           type="file"
                           accept={ACCEPTED_DOC_EXTENSIONS}
                           onChange={handleMedicalCertificateFileChange}
                           style={{ display: 'none' }}
                        />
                        <Button type="primary" size="small" shape='round' onClick={handleMedicalCertificateUploadClick}>
                           <PaperClipOutlined />
                        </Button>
                     </>
                  )
                  : (
                     <Upload
                        beforeUpload={(file) => beforeDocUpload(file, docType)}
                        showUploadList={false}
                        accept={ACCEPTED_DOC_EXTENSIONS}
                     >
                        <Button type="primary" size="small" shape='round'>
                           <PaperClipOutlined />
                        </Button>
                     </Upload>
                  )
            }
            {
               documentPreviews[docType] &&
               <Button type="primary" size="small" shape='round' onClick={() => handleViewDoc(documentPreviews[docType])}>
                  <EyeOutlined />
               </Button>
            }
         </Space>
      );
   };

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div style={{ width: '100%', height: '70px', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}>
            <div className="header-logo" >
               <Image preview={false} src="/images/1TVETLogo.png" height="60px" alt="Don Bosco 1TVET" />
            </div>
         </div>
         <div style={{ width: '100%', display: 'flex', justifyContent: 'center', overflow: 'auto', backgroundColor: '#F2F2F2' }}>
            <div style={{ marginTop: '35px', marginBottom: '20px', width: '100%', maxWidth: '1000px', height: '100%', border: '1px solid #ccc', borderRadius: '7px', backgroundColor: '#FFF', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
               <div className='block-container'>
                  <div className="login-header align-left" style={{ margin: '35px 35px' }}>
                     <h3><span style={{ color: "#1B5596" }}>APPLICATION</span> FORM</h3>
                     <p className="text-muted" style={{ fontSize: '18px' }}>Learner's Profile Form</p>
                  </div>

                  <div className='align-right' style={{ width: '165px', height: '165px', paddingTop: '35px', paddingRight: '35px' }}>
                     <Dragger
                        showUploadList={false}
                        style={{ backgroundColor: '#fff', borderRadius: '7px', padding: '0px', border: '1px solid #ccc' }}
                        beforeUpload={(file) => beforeDocUpload(file, DOCUMENT_TYPES.picture)}
                        maxCount={1}
                        accept=".png,.jpg,.jpeg"
                     >
                        {
                           documentPreviews[DOCUMENT_TYPES.picture] !== null
                              ?
                              <div style={{
                                 display: "flex",
                                 justifyContent: "center",
                                 backgroundColor: '#FFF',
                                 borderRadius: '7px',
                                 height: '100px',
                              }}>
                                 <Image src={documentPreviews[DOCUMENT_TYPES.picture]} preview={false} height={'100%'} />
                              </div>
                              :
                              <>
                                 <UserOutlined />
                                 <div className="ant-upload-text">Upload</div>
                              </>
                        }
                     </Dragger>
                  </div>
               </div>

               <Form
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  layout='vertical'
                  style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px' }}
               >
                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Course Offering</Title>
                  </Divider>
                  <Row gutter={[12, 12]}>                     
                     <Col xs={24} sm={24} md={12} lg={12}>
                        <div style={{ marginBottom: 12 }}>
                           <Text style={{ display: 'block', marginBottom: 6 }}>Select Program</Text>
                           <Radio.Group onChange={handleProgramTypeChange} value={programType}>
                              <Radio value="certificate">Certificate Program</Radio>
                              <Radio value="diploma" disabled>Diploma Program</Radio>
                           </Radio.Group>
                        </div>
                        <Form.Item
                           name={'first_choice'}
                           label="Select Course"
                           rules={[{ required: true, message: 'Course is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Select
                              showArrow
                              onChange={handleFirstChoice}
                              value={firstChoice}
                           >
                              {
                                 filteredCourseOffering.length > 0 &&
                                 filteredCourseOffering.map(({ value, name }) => (
                                    <Select.Option key={value} value={value}>{name}</Select.Option>
                                 ))
                              }
                           </Select>
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={12} lg={12}>
                        <table style={{ width: '100%', textAlign: 'left', borderRadius: '7px' }}>
                           <thead style={{ backgroundColor: '#f2b600', color: '#000' }}>
                              <tr>
                                 <th style={{ border: '1px solid #cdcdcd', padding: 10 }}>Feature</th>
                                 <th style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate' ? 'Certificate Program' : 'Diploma Program'}
                                 </th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}><strong>Duration</strong></td>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate'
                                       ? 'Short-term (varies by course) 12 months'
                                       : 'Typically 2 to 3 years (ladderized program)'}
                                 </td>
                              </tr>
                              <tr>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}><strong>Focus</strong></td>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate'
                                       ? 'Specialized, function-specific skills'
                                       : 'Technical, general education, & management'}
                                 </td>
                              </tr>
                              <tr>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}><strong>Goal</strong></td>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate'
                                       ? 'Immediate job-ready competency'
                                       : 'Higher-level technical mastery & career growth'}
                                 </td>
                              </tr>
                              <tr>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}><strong>Qualification</strong></td>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate'
                                       ? 'NC I, II, III, IV or CoC'
                                       : 'Aligned with PQF Level 5'}
                                 </td>
                              </tr>
                              <tr>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}><strong>Pathways</strong></td>
                                 <td style={{ border: '1px solid #cdcdcd', padding: 10 }}>
                                    {programType === 'certificate'
                                       ? 'Focuses on direct industry entry'
                                       : 'Includes credit transfer to college degrees'}
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </Col>
                  </Row>
                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Learner's Profile</Title>
                  </Divider>

                  <Row gutter={12}>
                     <Col xs={24} sm={24} md={24} lg={24}>
                        <h6>Name</h6>
                     </Col>
                  </Row>
                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'last_name'}
                           label="Last Name, Extension (eg. Jr., Sr.)"
                           rules={[{ required: true, message: 'Last Name is required' }]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input placeholder="Dela Cruz" id={'last_name'} name={'last_name'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'first_name'}
                           label="First Name"
                           rules={[{ required: true, message: 'First Name is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input placeholder="Juan" id={'first_name'} name={'first_name'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'middle_name'}
                           label="Middle Name"
                           // rules={[{ required: true, message: 'Middle Name is required' }]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'middle_name'} name={'middle_name'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>
                  <Row gutter={12}>
                     <Col xs={24} sm={24} md={24} lg={24}>
                        <h6>Complete Permanent Mailing Address</h6>
                     </Col>
                  </Row>
                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'number_street'}
                           label="Number, Street"
                           //rules={[{ required: true, message: ''},]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'number_street'} name={'number_street'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'barangay'}
                           label="Barangay"
                           rules={[{ required: true, message: 'Barangay is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'barangay'} name={'barangay'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'district'}
                           label="District"
                           //rules={[{ required: true, },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'district'} name={'district'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>
                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'city_municipality'}
                           label="City/Municipality"
                           rules={[{ required: true, message: 'City/Municipality is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'city_municipality'} name={'city_municipality'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'province'}
                           label="Province"
                           rules={[{ required: true, message: 'Province is required'},]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'province'} name={'province'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'region'}
                           label="Region"
                           rules={[{ required: true, message: 'Region is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'region'} name={'region'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>
                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'email'}
                           label="Email Address"
                           rules={[{ required: true, type: 'email', message: 'Email is required' }]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'email'} name={'email'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'contact_no'}
                           label="Contact No."
                           rules={[{ required: true, message: 'Contact No. is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'contact_no'} name={'contact_no'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'nationality'}
                           label="Nationality"
                           rules={[{ required: true, message: 'Nationality is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'nationality'} name={'nationality'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Personal Information</Title>
                  </Divider>

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'gender'}
                           label="Sex"
                           rules={[{ required: true, message: 'Gender is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Radio.Group
                              id={'gender'}
                              name={'gender'}
                           >
                              <Radio value="male">Male</Radio>
                              <Radio value="female">Female</Radio>
                           </Radio.Group>
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'civil_status'}
                           label="Civil Status"
                           rules={[{ required: true, message: 'Civil Status is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Radio.Group
                              id={'civil_status'}
                              name={'civil_status'}
                           >
                              <Radio value="single">Single</Radio>
                              <Radio value="married">Married</Radio>
                              <Radio value="widower">Widower</Radio>
                              <Radio value="separated">Separated</Radio>
                              <Radio value="solo_parent">Solo Parent</Radio>
                           </Radio.Group>
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <Form.Item
                           name={'employment_status'}
                           label="Employment Status"
                           rules={[{ required: true, message: 'Employment Status is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Radio.Group
                              id={'employment_status'}
                              name={'employment_status'}
                           >
                              <Radio value="employed">Employed</Radio>
                              <Radio value="unemployed">Unemployed</Radio>
                           </Radio.Group>
                        </Form.Item>
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#eee', margin: '0px 0px' }} />

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={6} lg={6}>
                        <Form.Item
                           name={'birth_date'}
                           label="Birth Date"
                           rules={[{ required: true, message: 'Birth Date is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <DatePicker
                              id={'birth_date'}
                              name={'birth_date'}
                              style={{ width: "100%" }}
                              format={'MMMM D, YYYY'}
                           />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={18} lg={18}>
                        <Form.Item
                           name={'birth_place'}
                           label="Birth Place (City/Municipality, Province, Region)"
                           rules={[{ required: true, message: 'Birth Place is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'birth_place'} name={'birth_place'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#eee', margin: '0px 0px' }} />

                  <Row gutter={[12, 12]} style={{ width: "100%" }}>
                     <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                           name={'educational_attainment'}
                           label="Educational Attainment Before the Training (Trainee)"
                           rules={[{ required: true, message: 'Educational Attainment is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Radio.Group
                              id={'educational_attainment'}
                              name={'educational_attainment'}
                              style={{ width: '100%' }}
                           >
                              <Row>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="no_grade_completed">No Grade Completed</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="pre_school">Pre-School</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="high_school_undergraduate">High School Undergraduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="high_school_graduate">High School Graduate</Radio>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="elementary_undergraduate">Elementary Undergraduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="post_secondary_undergraduate">Post Secondary Undergraduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="college_undergraduate">College Undergraduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="college_graduate">College Graduate or Higher</Radio>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="elementary_graduate">Elementary Graduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="post_secondary_graduate">Post Secondary Graduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="junior_high_graduate">Junior High Graduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="senior_high_graduate">Senior High Graduate</Radio>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="als_hs_graduate">ALS/High School Graduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    <Radio value="tvet_post_secondary_graduate">TVET/Post Secondary Graduate</Radio>
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    &nbsp
                                 </Col>
                                 <Col xs={24} sm={24} md={6} lg={6}>
                                    &nbsp
                                 </Col>
                              </Row>
                           </Radio.Group>
                        </Form.Item>
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#eee', margin: '0px 0px' }} />

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={7} lg={7}>
                        <Form.Item
                           name={'parent_guardian_name'}
                           label="Parent/Guardian Name"
                           rules={[{ required: true, message: 'Parent/Guardian Name is required' },]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'parent_guardian_name'} name={'parent_guardian_name'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                     <Col xs={24} sm={24} md={17} lg={17}>
                        <Form.Item
                           name={'parent_guardian_address'}
                           label="Parent/Guardian Complete Permanent Mailing Address"
                           rules={[{ required: true, message: 'Parent/Guardian Mailing Address is required' }]}
                           style={{ marginBottom: '10px' }}
                        >
                           <Input id={'parent_guardian_address'} name={'parent_guardian_address'} style={{ borderRadius: '7px' }} />
                        </Form.Item>
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Required Documents</Title>
                  </Divider>

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={24} lg={24}>
                        {
                           DOCUMENT_UPLOAD_ITEMS.map(({ key, label }) => (
                              <li key={key} style={{ marginBottom: '5px' }}>
                                 {label} {renderDocumentUploadAction(key)}
                              </li>
                           ))
                        }
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Fee / Payment Facilities</Title>
                  </Divider>

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        <li style={{ marginBottom: '5px' }}>Admission Fee: ₱{oaData !== null ? oaData.testing_fee : ''}</li>
                        {
                           requiresPaymentProof
                              ? (
                                 <li style={{ marginBottom: '5px' }}>
                                    Proof of Payment {renderDocumentUploadAction(DOCUMENT_TYPES.proofOfPayment)}
                                 </li>
                              )
                              : <li style={{ marginBottom: '5px' }}>No payment upload required.</li>
                        }
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                     </Col>
                     <Col xs={24} sm={24} md={8} lg={8}>
                        {
                           oaData !== null &&
                           (oaData.bank_details !== null && oaData.bank_details !== undefined) &&
                           <>
                              <Space direction='vertical' style={{ width: '100%' }}>
                                 {oaData.bank_details.map(({ qr_code }) => {
                                    return (
                                       qr_code !== null && qr_code !== "" &&
                                       <li key={qr_code} style={{ paddingBottom: '15px' }}>
                                          <Row>
                                             <Col span={24}>
                                                <Space direction='vertical' style={{ width: '100%' }}>
                                                   <Image src={`../images/${qr_code}`} preview={false} height="300px" />
                                                </Space>
                                             </Col>
                                          </Row>
                                       </li>
                                    )
                                 })}
                              </Space>
                           </>
                        }
                     </Col>
                  </Row>

                  <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                     <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>Privacy Statement</Title>
                  </Divider>

                  <Row gutter={[12, 12]}>
                     <Col xs={24} sm={24} md={24} lg={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <i>I hereby allow Don Bosco Training Centers to use/post my contact details, name, email, cellphone/landline nos. and other information I provided which may be used for processing of my scholarship application, for employment opportunities and for the survey of Don Bosco TVET programs.</i>
                     </Col>
                  </Row>

                  <Row gutter={[12, 12]} style={{ paddingTop: '20px' }}>
                     <Col xs={24} sm={24} md={24} lg={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Text>By clicking <span style={{ color: '#033D89' }}>Submit Application</span>, you agree to our privacy statement.</Text>
                     </Col>
                  </Row>

                  <Row gutter={[12, 12]} style={{ padding: '15px 0px 15px 0px' }}>
                     <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='button-shadow' type='primary' shape='round' htmlType="submit" disabled={(oaData.has_online_application !== null && oaData.has_online_application === "no" ? true : false)}>Submit Application</Button>
                     </Col>
                  </Row>

               </Form>
            </div>
         </div >
         <div style={{ width: '100%', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}>
            Powered by CAMPUSCLOUD IT CONSULTANCY ©2024
         </div>

         <Modal
            key='preview-doc'
            title={"Preview "}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={modalVisible}
            width='75%'

            onCancel={() => { setModalVisible(false); }}
            onOk={() => { setModalVisible(false); }}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               {renderPreviewer(docToView)}
            </div>
         </Modal>

         <Modal
            key='confirm_submit'
            title={"Submit Application"}
            centered
            destroyOnClose={true}
            open={modalSubmit}

            footer={[
               <Button key="notpaid" type='primary' shape='round' onClick={() => handleSubmitApplication(formValues)}>Submit</Button>,
               <Button key="close" type="primary" shape='round' onClick={() => setModalSubmit(false)}>Cancel</Button>
            ]}
         >
            <Text>REMINDER: Kindly verify your email address and contact number before submitting your application. These details are essential for effective communication during the processing of your application.</Text>
         </Modal>
      </>
   )
}
